<template>
  <div class="empty-state">
    <font-awesome-icon
      :icon="['fal', icon]"
      class="empty-state-icon"
    />
    <h4>{{ title }}</h4>
    <p class="empty-state-description">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    description: String,
    title: String,
    icon: String
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
    margin-top: 20px;
    text-align: center;
    .empty-state-icon {
        font-size: 6.4rem;
        color: $secondary-light;
    }
    .empty-state-description {
        font-size: 1.8rem;
        color: #000;
    }
}
</style>
